import React, { Component } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { utcToLocal, utcToDate } from "../../utils/dateConvert";
import TimeAgo from "timeago-react";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class AlertTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      //states for modal
      modalId: "",
      modalEvent: "",
      modalAsset: "",
      modalCreated: "",
      modalDifference: "",
      modalAddress: "",
      modalCutomerName: "",
      acknowledgementDescription: "",
      modalUserId: "",
      ackDesc: "",
      modalAcknowledgeTime: "",
      modalUserName: "",
      // rowColor: false,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      console.log("this.props", this.props.data);
    }, 2000);
  }
  handleClose = () => {
    this.setState({
      modalShow: false,
    });
  };
  acknowledgeClick = (id, description) => {
    this.props.handleAcknowledege(id, description);
    // this.props.setLoadingPageAction(true);
    this.setState({
      modalShow: false,
      rowColor: false,
      acknowledgementDescription:''
    });
    // this.props.rowColor(false)
  };

  handleAcknowledegmentDescription = (e) => {
    console.log("etarget", e.target.value);
    this.setState({
      acknowledgementDescription: e.target.value,
    });
  };
  handleAcknowledged = (
    event,
    asset,
    created,
    difference,
    address,
    customer,
    id,
    userId,
    ackMsg,
    usrname,
    ackTime
  ) => {
    this.setState({
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
      modalUserId: userId,
      ackDesc: ackMsg,
      modalUserName: usrname,
      modalAcknowledgeTime: ackTime,
    });
  };
  handleShow = (event, asset, created, difference, address, customer, id) => {
    this.setState({
      modalUserId: "",
      ackDesc: "",
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
    });
  };

  renderEvents = (event, index) => {
      if (this.props.isTemperature) {
          return this.renderTemperatureEvent(event, index);
      } else {
          // Existing event rendering logic
          return (
              <tr
                  key={index}
                  style={
                      event.userId
                          ? { background: "#DFF0D9" }
                          : { position: "relative" }
                  }
                  className={`${event.rowColor ? "tableRowFlicker" : ""} `}
              >
                  <td>
                      <i style={event.eventId == 5 ? { color: '#a94442' } : { color: '#8a6d3b' }} className={`fa ${event.eventId == 403 ? "fa-reply-all" : event.eventId == 405 ? "fa-exclamation-circle" : event.eventId == 404 ? "fa-flag-checkered" : "fa-life-buoy"} `}></i>

                      &nbsp;
                      {event.uniqueId !== null && event.uniqueId !== 0 ? event.eventName + " - [" + event.uniqueId + "]" : event.eventName}
                      </td>
                  <td>
                      {" "}
                      {
                          <TimeAgo
                              datetime={utcToLocal(event.gPRMC.created)}
                          // locale='zh_CN'
                          />
                      }{" "}
                      - {utcToDate(event.gPRMC.created)}
                  </td>

                  <td>{event.assetName}</td>
                  <td>{event.customerName}</td>
                  <td>{event.location}</td>
                  <td>
                      <center>
                          {event.userId ? (
                              <div>
                                  {utcToLocal(event.acknowledgeTime)}
                                  <br />
                                  <button
                                      className="info"
                                      onClick={() =>
                                          this.handleAcknowledged(
                                              event.eventName,
                                              event.assetName,
                                              event.created,
                                              event.difference,
                                              event.location,
                                              event.customerName,
                                              event.id,
                                              event.userId,
                                              event.acknowledgedDescription,
                                              event.userName,
                                              event.acknowledgeTime
                                          )
                                      }
                                  >
                                      <i className="fa fa-info" />
                                  </button>
                              </div>
                          ) : (
                              <Button
                                  variant="danger"
                                  onClick={() => {

                                      this.handleShow(
                                          event.eventName,
                                          event.assetName,
                                          event.created,
                                          event.difference,
                                          event.location,
                                          event.customerName,
                                          event.id
                                      )
                                  }}
                                  size="sm"
                              >
                                  <i className="fa fa-check" />
                              </Button>
                          )}
                      </center>
                  </td>
              </tr>
          );
      }
  };

  renderTemperatureEvent = (event, index) => {
      return (
          <tr key={index} className={event.rowColor ? "highlight-row" : ""}>
              <td>Out of Threshold</td>
              <td>{event.tempAlertSensor}</td>
              <td>{`${event.tempAlertRuleType} ${event.tempAlertThreshold}°C`}</td>
              <td>{event.sensorAValue || event.sensorBValue}</td>
              <td>{this.formatDateTime(event.tempAlertStartTime || event.created)}</td>
              <td>{this.formatDateTime(event.tempAlertEndTime)}</td>
              <td>{event.tempAlertDuration} mins</td>
              <td>{event.friendlyName || event.assetName}</td>
              <td>{event.customerName}</td>
              <td>{event.tempAlertStartAddress || event.location}</td>
              <td>{event.tempAlertEndAddress || event.location}</td>
              <td>{event.tempAlertEmailSent}</td>
              <td>
                  {event.userId === null ? (
                      <button
                          className="btn btn-primary acknow-btn"
                          onClick={() => this.handleAcknowledgeButton(event)}
                      >
                          Acknowledge
                      </button>
                  ) : (
                      <>
                          <p className="alert-user">
                              {event.userName}
                          </p>
                          <p className="alert-description">
                              {event.acknowledgedDescription}
                          </p>
                          <p className="alert-time">
                              {this.formatDateTime(event.acknowledgeTime)}
                          </p>
                      </>
                  )}
              </td>
          </tr>
      );
  };

  renderTableHeader = () => {
      if (this.props.isTemperature) {
          return (
              <tr>
                  <th>Event</th>
                  <th>Sensor</th>
                  <th>Threshold</th>
                  <th>Recorded Temperature</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Duration</th>
                  <th>Asset</th>
                  <th>Customer</th>
                  <th>Start Address</th>
                  <th>End Address</th>
                  <th>Emailed</th>
                  <th>Acknowledge</th>
              </tr>
          );
      } else {
          return (
              <tr>
                  <th>Status</th>
                  <th>Event</th>
                  <th>Asset Name</th>
                  <th>Friendly Name</th>
                  <th>Customer</th>
                  <th>Location</th>
                  <th>Acknowledge</th>
              </tr>
          );
      }
  };

  formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const date = new Date(dateTimeStr);
    return date.toLocaleString();
  };
  
  handleAcknowledgeButton = (event) => {
    this.setState({
      show: true,
      info: {
        ...this.state.info,
        event: event.eventName || "Temperature Alert",
        assetName: event.friendlyName || event.assetName,
        time: event.created || event.tempAlertStartTime,
        location: event.location || event.tempAlertStartAddress,
        customer: event.customerName,
        id: event.id,
      },
    });
  };

  render() {

    return (
      <div className="borderBox">
        <div className="heading">
          <h3>{this.props.alertMessage}</h3>
          <i onClick={() => this.props.downloadExcel()} className="fa fa-file-excel-o" />
        </div>
        {/* <hr/> */}
        <Table striped>
          <thead>
            <tr>
              <th>Event</th>
              <th>Occured</th>
              <th>Asset</th>
              <th>Customer</th>
              <th>Address</th>
              <th>
                <center>Acknowledged</center>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.props.data !== ""
              ? this.props.data.map((item, index) => {
                return (
                  <tr
                    key={index}
                    style={
                      item.userId
                        ? { background: "#DFF0D9" }
                        : { position: "relative" }
                    }
                    className={`${item.rowColor ? "tableRowFlicker" : ""} `}
                  >
                    <td>
                      <i style={item.eventId == 5 ? { color: '#a94442' } : { color: '#8a6d3b' }} className={`fa ${item.eventId == 403 ? "fa-reply-all" : item.eventId == 405 ? "fa-exclamation-circle" : item.eventId == 404 ? "fa-flag-checkered" : "fa-life-buoy"} `}></i>

                      &nbsp;
                      {item.uniqueId !== null && item.uniqueId !== 0 ? item.eventName + " - [" + item.uniqueId + "]" : item.eventName}
                      </td>
                    <td>
                      {" "}
                      {
                        <TimeAgo
                          datetime={utcToLocal(item.gPRMC.created)}
                        // locale='zh_CN'
                        />
                      }{" "}
                      - {utcToDate(item.gPRMC.created)}
                    </td>

                    <td>{item.assetName}</td>
                    <td>{item.customerName}</td>
                    <td>{item.location}</td>
                    <td>
                      <center>
                        {item.userId ? (
                          <div>
                            {utcToLocal(item.acknowledgeTime)}
                            <br />
                            <button
                              className="info"
                              onClick={() =>
                                this.handleAcknowledged(
                                  item.eventName,
                                  item.assetName,
                                  item.created,
                                  item.difference,
                                  item.location,
                                  item.customerName,
                                  item.id,
                                  item.userId,
                                  item.acknowledgedDescription,
                                  item.userName,
                                  item.acknowledgeTime
                                )
                              }
                            >
                              <i className="fa fa-info" />
                            </button>
                          </div>
                        ) : (
                          <Button
                            variant="danger"
                            onClick={() => {

                              this.handleShow(
                                item.eventName,
                                item.assetName,
                                item.created,
                                item.difference,
                                item.location,
                                item.customerName,
                                item.id
                              )
                            }}
                            size="sm"
                          >
                            <i className="fa fa-check" />
                          </Button>
                        )}
                      </center>
                    </td>
                  </tr>
                );
              })
              : ""}
            <Modal
              show={this.state.modalShow}
              size="lg"
              onHide={this.handleClose}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {this.state.modalUserId == "" ? (
                    "Acknowledge alert"
                  ) : (
                    <b>{this.state.modalEvent}</b>
                  )}{" "}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.modalUserId == "" ? (
                  <span>
                    <b>{this.state.modalEvent}</b> was triggered by{" "}
                  </span>
                ) : (
                  "Triggered by "
                )}
                <b>{this.state.modalAsset}</b> on{" "}
                {utcToDate(this.state.modalCreated)}{" "}
                <TimeAgo datetime={this.state.modalDifference} />.
                <br />
                {this.state.modalAddress}
                <br />
                <b>Customer</b> {this.state.modalCutomerName}
                <br />
                {this.state.modalUserId !== "" ? (
                  <div>
                    Acknowledge Message:<b>{this.state.ackDesc}</b>
                  </div>
                ) : (
                  <br />
                )}
                {this.state.modalUserId == "" ? (
                  <div>
                    <b>Remarks</b>
                    <Form>
                      <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Control
                          as="textarea"
                          onChange={this.handleAcknowledegmentDescription}
                          placeholder="Optional remarks about your acknowledgement"
                          rows="3"
                        />
                      </Form.Group>
                    </Form>
                    <p className="modalGraph">
                      By acknowledging this alert you are confirming it has
                      occurred and that it no longer needs to be included in the
                      alert centre notification area. This action and your
                      remarks will be viewable by others.
                      <br />
                      <b>NOTE:</b> Once Alerts are over 24 hours old they are
                      automaticaly removed from the alert centre notification
                      area.
                    </p>
                  </div>
                ) : (
                  <div>
                    Acknowledged by {this.state.modalUserName} on{" "}
                    {utcToDate(this.state.modalAcknowledgeTime)}
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                {this.state.modalUserId == "" ? (
                  <div>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => {
                        this.acknowledgeClick(
                          this.state.modalId,
                          this.state.acknowledgementDescription
                        )
                      }}
                    >
                      Acknowledge
                    </Button>
                    &nbsp;
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={this.handleClose}
                    >
                      Cancel
                    </Button>
                  </div>
                ) : (
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={this.handleClose}
                  >
                    Ok
                  </Button>
                )}
              </Modal.Footer>
            </Modal>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertTable);
